import clsx from 'clsx';
import A from 'components/atoms/A/A';
import Card from 'components/atoms/Card/Card';
import Txt from 'components/atoms/Txt/Txt';
import Clock from './assets/clock.svg';
import BannerChevron from './assets/banner-chevron.svg';
import QmeePerson from './assets/qmee-person.svg';
import Basic_Survey_Profile from './assets/Basic_Survey_Profile.svg';
import classes from './InitialProfiler.qmee.module.scss';
import { useMoreSurveysBannerQuery_profileUrlRef$data } from './__generated__/useMoreSurveysBannerQuery_profileUrlRef.graphql';

export type Props = {
  data: useMoreSurveysBannerQuery_profileUrlRef$data;
  className: string;
};

export default function InitialProfiler({ data, className }: Props) {
  if (!data.profilerUrl) {
    return null;
  }

  const versionTwoLink = `${data.profilerUrl}&v2=true`;

  return (
    <Card className={clsx(classes.root, className)}>
      <Basic_Survey_Profile className={classes.qmeeLgPersonTopRight} />
      <QmeePerson className={classes.qmeeMobPersonTopRight} />
      <A href={versionTwoLink} className={classes.innerLink}>
        <div className={classes.userRow}>
          <Txt className={classes.userName} skipTranslation>
            Basic Survey Profile
          </Txt>
        </div>
        <Txt className={classes.text}>
          Start matching yourself to relevant surveys and start earning.
        </Txt>
        <div className={classes.cta}>
          <Txt className={classes.matchMe}>Match me to surveys</Txt>
          <span className={classes.duration}>
            <Txt>
              <Clock className={classes.clock} />
              <Txt className={classes.minutes} skipTranslation>
                {{ duration: 3 }}
              </Txt>{' '}
              <span className={classes.units}>mins</span>
            </Txt>
            <BannerChevron className={classes.chevron} />
          </span>
        </div>
      </A>
    </Card>
  );
}
